import type { Accounts } from '@aviata/platform-types';

import { api } from '@/shared/api';
import { sentryModel } from '@/shared/model';

export const createPassenger = async (
  userId: string,
  passenger: Partial<Accounts.Passenger>,
): Promise<Accounts.Passenger> => {
  try {
    const response = await api.client.post<Accounts.Passenger>(
      `/accounts/${userId}/passengers`,
      passenger,
    );
    return response.data;
  } catch (error) {
    sentryModel.captureException(
      sentryModel.getReadableError(
        'ERR_FAILED_TO_CREATE_PASSENGER',
        error as Error,
      ),
    );
    throw error;
  }
};

export const editPassenger = (
  userId: string,
  passenger: Partial<Accounts.Passenger>,
) => {
  try {
    api.client.patch(
      `/accounts/${userId}/passengers/${passenger.id}`,
      passenger,
    );
  } catch (error) {
    sentryModel.captureException(
      sentryModel.getReadableError(
        'ERR_FAILED_TO_EDIT_PASSENGER',
        error as Error,
      ),
    );
    throw error;
  }
};
